<div class="absolute-center card card--shadow-level-1 col-10 col-lg-4 col-md-6 col-xl-4">
    <div class="card-group">
        <div class="card-body">
            <div class="alert alert-danger" role="alert">
                <div class="d-inline-flex">
                    <bb-icon-ui name="error" size="md" color="primary"></bb-icon-ui>
                    <div>
                        <span class="font-weight-bold ml-2">{{ bannerMessage }}</span> <br>
                        <!-- <span class="ml-2">{{ description }}</span> -->
                    </div>
                </div>
            </div>
            <bb-collapsible-ui #collapsible>
                <ng-template bbCollapsibleHeader let-toggle="toggle" let-isOpen="true">
                    <button bbButton (click)="toggle()" class="bb-button-bar__button"
                        [attr.aria-expanded]="collapsible.isOpen" aria-controls="collapseBody"> Contact Customer Care
                        <bb-icon-ui [name]="collapsible.isOpen ? 'toggle-up' : 'toggle-down'" [inverse]="true"
                            size="md"></bb-icon-ui>
                    </button>
                </ng-template>
                <ng-template bbCollapsibleBody>
                    <p id="collapseBody" class="mt-2">
                        Contact customer care on +2547110689888 or email: <span>
                            <a href="mailto:ibkenya&#64;stanbic.com">ibkenya&#64;stanbic.com</a>
                        </span>
                    </p>
                </ng-template>
            </bb-collapsible-ui>
        </div>
    </div>
</div>